// web/src/components/StatusBadge.tsx — icon + label + tone (never color-only). Reads STATUS_UI (D05).
import type { RunStatus } from '../lib/types';
import { STATUS_UI, TONE_TEXT, TONE_BORDER } from '../lib/status';
import { Icon } from './Icon';

export function StatusBadge({ status }: { status: RunStatus }) {
  const s = STATUS_UI[status];
  return (
    <span className={`inline-flex shrink-0 items-center gap-1.5 rounded-pill border px-2.5 py-1 text-xs ${TONE_TEXT[s.tone]} ${TONE_BORDER[s.tone]}`}>
      <Icon name={s.icon} size={13} className={s.icon === 'loader' ? 'animate-spin' : ''} />
      {s.label}
    </span>
  );
}
